<script lang="ts">
  import { clickOutside } from '$src/utils/clickOutside.util';
  import { slide } from 'svelte/transition';
  import TextInputWithRightButton from '../inputs/textInputs/TextInputWithRightButton.svelte';
  import RangeDatepicker from '../datepickers/Range.svelte';
  import Close from '$icons/CloseAltIcon.svelte';
  import Calendar from '$icons/CalendarIcon.svelte';
  import { createEventDispatcher } from 'svelte';

  export let label = '';
  export let caption = '';
  export let startDate: Date = null;
  export let endDate: Date = null;
  export let selectedRange: Date[] = [];
  export let danger: boolean = false;
  export let dangerMessage: string = '';

  export let dropdownOpen = false;
  export let inputFocused = false;
  export let dropdownAlign: 'left' | 'right' | 'center' = 'right';

  let dateRangeInputRegex =
    /^(\d{0,2}(\/\d{0,2}(\/\d{0,4})?)?(\s*-\s?\d{0,2}(\/\d{0,2}(\/\d{0,4})?)?)?)?$/;

  ///^(\d{0,2}(\/\d{0,2}(\/\d{0,4})?)?)?$/

  const dispatch = createEventDispatcher();

  $: value = startDate
    ? `${new Date(startDate).toLocaleDateString('en-IN').split('/').join(' / ')} - ${
        endDate
          ? new Date(endDate).toLocaleDateString('en-IN').split('/').join(' / ')
          : 'DD / MM / YYYY'
      }`
    : '';

  let placeholder = 'DD / MM / YYYY - DD / MM / YYYY';
  $: dropdownClicked = false;

  $: {
    dispatch('change', { value, startDate, endDate });
  }

  $: {
    dropdownOpen = inputFocused || dropdownClicked;
  }

  const convertRangeStringIntoDates = (rangeString: string) => {
    if (!dateRangeInputRegex.test(rangeString)) return;

    const firstDate = rangeString.split('-')[0].trim();
    const secondDate = rangeString.split('-')[1].trim();

    const tempStartDate = new Date(
      Number(firstDate.split('/')[2]),
      Number(firstDate.split('/')[1]) - 1,
      Number(firstDate.split('/')[0])
    );
    const tempEndDate = new Date(
      Number(secondDate.split('/')[2]),
      Number(secondDate.split('/')[1]) - 1,
      Number(secondDate.split('/')[0])
    );

    const today = new Date();

    if (
      tempStartDate >= tempEndDate ||
      tempStartDate >= today ||
      tempEndDate > today ||
      !tempStartDate ||
      !tempEndDate
    ) {
      return;
    }

    startDate = tempStartDate;
    endDate = tempEndDate;
  };
</script>

<div
  class="relative w-full"
  use:clickOutside
  on:click_outside={() => {
    dropdownOpen = false;
    inputFocused = false;
  }}
>
  <TextInputWithRightButton
    bind:label
    bind:caption
    bind:value
    bind:placeholder
    bind:danger
    bind:dangerMessage
    bind:inputFocused
    inputRegex={dateRangeInputRegex}
    inputVerifing={true}
    on:change={e => convertRangeStringIntoDates(e.detail)}
  >
    <button
      class="flex flex-row justify-center items-center cursor-pointer select-none"
      on:click|stopPropagation={() => {
        dropdownOpen = !dropdownOpen;
        inputFocused = dropdownOpen;
      }}
      on:keydown
    >
      {#if !dropdownOpen}
        <Calendar />
      {:else}
        <Close size="24" color="#0F9D58" />
      {/if}
    </button>
  </TextInputWithRightButton>
  {#if dropdownOpen}
    <button
      class="dropdown mx-auto w-min"
      class:right-0={dropdownAlign === 'right' || dropdownAlign === 'center'}
      class:left-0={dropdownAlign === 'left' || dropdownAlign === 'center'}
      class:-mt-4={!caption}
      class:mt-1={caption}
      on:keydown
      on:click={() => {
        dropdownClicked = true;
      }}
      use:clickOutside
      on:click_outside={() => {
        dropdownClicked = false;
      }}
      in:slide|global={{ duration: 200 }}
      out:slide|global={{ duration: 200 }}
    >
      <RangeDatepicker bind:startDate bind:endDate bind:selectedRange />
    </button>
  {/if}
</div>

<style type="postcss">
  .dropdown {
    @apply overflow-y-auto absolute z-50 bg-white rounded-2xl right-0 mt-2 text-sm font-medium flex flex-col;
    box-shadow:
      0px 12px 16px -4px rgba(16, 24, 40, 0.08),
      0px 4px 6px -2px rgba(16, 24, 40, 0.03);
  }
</style>
